export default {"src":"/_next/static/media/close.fa55fb5b.svg","height":20,"width":20};